
import React from 'react';

export default function Portfolio({ item, index }) {
  const isEven = index % 2 === 0;

  return (
    <div className={`flex flex-col md:flex-row items-center gap-12 mb-24 relative ${isEven ? '' : 'md:flex-row-reverse'}`}>

      {/* Connector Line (visual flair) */}
      <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-crimson/20 to-transparent -translate-x-1/2"></div>

      {/* Image Side */}
      <div className="w-full md:w-1/2 relative group">
        {/* Decorative Shape behind image */}
        <div className={`absolute top-4 ${isEven ? '-left-4' : '-right-4'} w-full h-full rounded-[2rem] bg-paper transform transition-transform group-hover:scale-105 duration-500`}></div>

        <div className="relative overflow-hidden rounded-[2rem] shadow-xl aspect-video bg-white">
          <img
            src={require(`../images/${item.img}`)}
            className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-110"
            alt={item.title}
          />
        </div>
      </div>

      {/* Content Side */}
      <div className="w-full md:w-1/2 flex flex-col gap-6 z-10">
        <h2 className={`text-4xl font-bold text-active ${isEven ? 'md:text-left' : 'md:text-right'} text-center`}>
          {item.title}
        </h2>

        <p className={`text-xl text-active/80 leading-relaxed ${isEven ? 'md:text-left' : 'md:text-right'} text-center`}>
          {item.description}
        </p>

        <ul className={`flex flex-wrap gap-3 ${isEven ? 'justify-center md:justify-start' : 'justify-center md:justify-end'}`}>
          {item.skills.map((skill, idx) => (
            <li key={idx} className="px-4 py-1.5 text-sm font-medium rounded-full bg-nudeBlush/30 text-crimson border border-nudeBlush/50">
              {skill}
            </li>
          ))}
        </ul>

        {/* Buttons - Always Visible */}
        <div className={`flex flex-wrap gap-4 mt-2 ${isEven ? 'justify-center md:justify-start' : 'justify-center md:justify-end'}`}>
          {item.github && (
            <a href={item.github} target="_blank" rel='noreferrer'
              className="px-8 py-3 bg-white border-2 border-nudeBlush rounded-full font-bold text-active hover:bg-crimson hover:text-white hover:border-crimson transition-all duration-300 shadow-sm">
              GitHub
            </a>
          )}
          {item.live && (
            <a href={item.live} target="_blank" rel='noreferrer'
              className="px-8 py-3 bg-crimson border-2 border-crimson rounded-full font-bold text-white hover:bg-white hover:text-crimson transition-all duration-300 shadow-lg hover:shadow-xl">
              View Live
            </a>
          )}
        </div>
      </div>

    </div>
  );
}